import {
  GamesOrderType,
  ModuleContentBlocksContent,
  ModuleLayout,
  ModuleType,
  BonusObtainType,
  ModuleIcon,
  ModuleTopPrivacyTipsBlockContent,
  ModuleGame,
  TagMatchRule,
} from "entities/modules/types";
import { Translations } from "shared/types/languages";

export type Page = {
  id: string;
  title: string;
  webTitle?: string;
  translations?: Translations;
  modulesCount: number;
  updatedAt: Date;
  isActive: boolean;
  order: number;
  path: string;
  description?: string;
  isDefaultForAuthenticated: boolean;
  isDefaultForUnauthenticated: boolean;
  showInBurgerMenu: boolean;
  showInDesktopHeaderMenu: boolean;
  showInMobileBurgerMenuQuickLinks: boolean;
  hasSearch?: boolean;
  isMaintenanceMode?: boolean;
  maintenanceModeDescription?: string;
  icon: PageIcon | null;
};

export type PageToUpdate = {
  id: string;
  title?: string;
  webTitle?: string;
  translations?: Translations;
  isActive?: boolean;
  order?: number;
  icon?: PageIcon | null;
  showInBurgerMenu?: boolean;
  hasSearch?: boolean;
  showInDesktopHeaderMenu?: boolean;
  showInMobileBurgerMenuQuickLinks?: boolean;
};

export enum PageModuleStatus {
  Active = "active",
  Draft = "draft",
  Expired = "expired",
}

export enum BrandTabs {
  Pages = "pages",
  Settings = "settings",
}

export type PageModuleData = {
  id: string;
  name: string;
  type: ModuleType;
  layout: ModuleLayout | null;
  status: PageModuleStatus;
  adminNotes: string | null;
  translations?: Translations;
  createdAt: Date;
  updatedAt: Date;
  tagTypes: string[];
  tags: string[];
  isAiGenerated?: boolean;
  gamesOrderType: GamesOrderType | null;
  manualSelectedGames: ModuleGame[];
  tagSelectedGames: ModuleGame[];
  selectedGames: ModuleGame[];
  selectedStudiosIds: string[];
  orderedGamesStudiosIds: string[];
  selectedGamesIdsByStudio: Record<string, string[]>;
  studioFilterEnabled: boolean;
  order: number;
  baseUrl?: string;
  rows?: number;
  contentBlocks?: ModuleContentBlocksContent[];
  topPrivacyTipsBlock?: ModuleTopPrivacyTipsBlockContent;
  bonusObtainType?: BonusObtainType | null;
  icon: ModuleIcon | null;
  scheduledStartAt?: string;
  scheduledEndAt?: string;
  relatedEvent?: {
    name: string;
  };
  tagsMatchRules?: TagMatchRule[];
};

export type PageModuleDataWithPageId = PageModuleData & {
  pageId: string;
  brandId: string;
};

export type PageModuleDataToCreate = Omit<
  PageModuleData,
  "id" | "createdAt" | "updatedAt"
>;

export type PageModuleDataToInsert = Omit<
  PageModuleData,
  "createdAt" | "updatedAt"
>;

export type PageModuleDataToUpdate = Partial<PageModuleDataToCreate>;

export type PageDataToCreate = Omit<Page, "id" | "updatedAt">;

export enum PageIcon {
  CheckmarkBadge = "checkmarkBadge",
  Chip = "chip",
  QuestionMark = "questionMark",
  Cards = "cards",
  Dice = "dice",
  Play = "play",
  Roulette = "roulette",
  Heart = "heart",
  Star = "star",
  Fire = "fire",
  Recently = "recently",
  Gift = "gift",
  Ticket = "ticket",
  TicketDiscount = "ticketDiscount",
  Puzzle = "puzzle",
  Time = "time",
  Info = "info",
  BadgeDiscount = "badgeDiscount",
  Trophy = "trophy",
  House = "house",
  CardPlay = "cardPlay",
  SportsBall = "sportsBall",
}
